import { defineStore } from "pinia";
import { Contact, JackBurtonApi, Utterance } from "@/services/api/sdk";
import { ApiConfiguration } from "@/services/api/api-configuration.ts";
import { computed, ref } from "vue";

export const useCallUtteranceStore = defineStore("call-utterances", () => {
    const utterances = ref<Record<string, Utterance>>({});
    const partialUtterance = ref<Utterance | null>(null);

    function $reset() {
        utterances.value = {};
        partialUtterance.value = null;
    }

    async function fetchUtterancesForCall(call: Contact): Promise<void> {
        const api = new JackBurtonApi(ApiConfiguration);
        const utterances = await api.getContactUtterances({
            contactId: call.id!,
        });

        utterances.forEach(addUtterance);
    }

    function addUtterance(utterance: Utterance): void {
        utterances.value = {
            ...utterances.value,
            [utterance.id!]: utterance,
        };
    }

    const allUtterances = computed<Utterance[]>(() => {
        return [
            ...Object.values(utterances.value),
            ...(partialUtterance.value ? [partialUtterance.value] : []),
        ];
    });

    return { $reset, utterances, partialUtterance, fetchUtterancesForCall, addUtterance, allUtterances }
});
